var _rect, _circle, _path, _circle2, _path2, _path3, _circle3, _circle4, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 208,
    viewBox: "0 0 220 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 63.8203,
    width: 61.0026,
    height: 61.0026,
    rx: 16,
    transform: "rotate(-20.959 31 63.8203)",
    fill: "#F2D8AE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.9709,
    cy: 150.971,
    r: 6.625,
    transform: "rotate(-13.2939 94.9709 150.971)",
    fill: "#49BDB6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5981 68.3924C96.5737 68.0341 96.5197 67.6731 96.4344 67.3121C95.5931 63.7513 92.0244 61.5467 88.4635 62.388C84.9027 63.2294 82.6981 66.798 83.5395 70.3589C83.5751 70.5098 83.6157 70.6584 83.661 70.8043C74.3203 75.5558 69.0207 86.2238 71.533 96.8567L74.3173 108.641C74.507 109.931 74.6415 111.178 74.7242 112.393L109.5 99.5173C114.933 97.5058 118.027 91.7731 116.727 86.1277C114.459 76.2753 106.135 69.3849 96.5981 68.3924Z",
    fill: "#49BDB6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.987,
    cy: 67.8352,
    r: 6.625,
    transform: "rotate(-13.2939 91.987 67.8352)",
    fill: "#F2D8AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.097 102.99C99.8737 90.5368 107.356 77.8286 119.809 74.6054C132.263 71.3822 144.971 78.8647 148.194 91.318L151.211 102.976C153.92 110.087 157.385 115.117 162.051 119.935C167.731 125.8 165.701 135.723 157.797 137.769L117.114 148.298C109.233 150.338 102.681 142.71 104.883 134.873C106.734 128.284 107.384 122.171 106.114 114.648L103.097 102.99Z",
    fill: "url(#paint0_linear_286_7029)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5484 97.9217C72.5904 85.4027 80.3411 72.8563 92.8601 69.8983C105.379 66.9404 117.925 74.6911 120.883 87.2101L123.652 98.929C126.209 106.096 129.567 111.199 134.129 116.115C139.683 122.099 137.443 131.977 129.498 133.854L88.6002 143.517C80.6778 145.389 74.2893 137.624 76.6569 129.835C78.6473 123.287 79.4273 117.189 78.3173 109.641L75.5484 97.9217Z",
    fill: "url(#paint1_linear_286_7029)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5,
    cy: 5,
    r: 5,
    transform: "matrix(1 0 0 -1 160 93)",
    fill: "#206583"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(1 0 0 -1 76 204)",
    fill: "#206583"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5867 33.6361C30.4393 30.7786 32.8156 27.7506 35.8639 28.1858L44.4372 29.4095C47.4855 29.8447 48.9197 33.4165 47.0187 35.8388L41.6722 42.6517C39.7712 45.074 35.9608 44.5301 34.8135 41.6727L31.5867 33.6361Z",
    fill: "#EEABAB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90299 149.369C6.69729 146.366 9.1944 143.184 12.3978 143.642C15.6012 144.099 17.1083 147.853 15.1106 150.398C13.1129 152.944 9.10869 152.372 7.90299 149.369Z",
    fill: "#EEABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.368 125.998C187.023 120.159 191.879 113.972 198.108 114.861C204.337 115.75 207.268 123.049 203.383 127.999C199.499 132.949 191.712 131.838 189.368 125.998Z",
    fill: "#EEABAB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.325 193.467C139.165 191.272 140.191 187.563 143.172 186.79L151.554 184.615C154.535 183.842 157.235 186.586 156.414 189.553L154.105 197.9C153.285 200.868 149.559 201.834 147.399 199.64L141.325 193.467Z",
    fill: "#EEABAB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M176.76 38.5844C173.919 45.7757 169.403 26.5391 162.211 23.6984C155.02 20.8578 137.049 22.0723 139.89 14.8811C142.73 7.6898 163.689 7.07889 170.88 9.91955C178.071 12.7602 179.601 31.3932 176.76 38.5844Z",
    fill: "#49BDB6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_7029",
    x1: 121.264,
    y1: 111.061,
    x2: 186.146,
    y2: 94.2687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_286_7029",
    x1: 93.54,
    y1: 106.377,
    x2: 158.764,
    y2: 90.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#226A86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotification);
export default __webpack_public_path__ + "static/media/emptyNotification.3712c2772121e03f57eeeee6d9186691.svg";
export { ForwardRef as ReactComponent };